import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { useCallback } from 'react';
import { PERMISSION_ALARM } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import AlarmForm from '../../components/Alarms/AlarmForm';
import { URL_ALARM } from '../../router/constants';

// Optional: opening the URL without ?customerId must not fail validation (the form handles it)
const editAlarmSearchSchema = z.object({
  customerId: z.coerce.number().optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/alarm/edit/$id')({
  validateSearch: editAlarmSearchSchema,
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_ALARM, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'alarms.subpage.editAlarm',
        suffix: 'menu.alarms',
      },
    };
  },
  // Loader: Use React Query to fetch alarm data before rendering
  // This provides caching, deduplication, and better integration with the component queries
  loader: async () => {
    // const id = Number(params.id);
    // Use ensureQueryData to fetch and cache the data
    // If already cached, it returns immediately; if not, it fetches
    // const [alarmData, validation] = await Promise.all([
    //   queryClient.ensureQueryData({
    //     queryKey: ['alarmFormData', id],
    //     queryFn: () => getData(id),
    //     staleTime: 1000 * 60 * 5, // Consider data fresh for 5 minutes
    //   }),
    //   queryClient.ensureQueryData({
    //     queryKey: ['alarmFormValidation'],
    //     queryFn: () => getValidation(),
    //     staleTime: 1000 * 60 * 10, // Consider validation fresh for 10 minutes
    //   }),
    // ]);
    // return {
    //   alarmData,
    //   validation,
    // };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: EditAlarmRoute,
});

function EditAlarmRoute() {
  const { id } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    navigate({ to: URL_ALARM });
  }, [navigate]);

  return (
    <div>
      <AlarmForm id={Number(id)} customerId={search?.customerId} closeCallback={handleClose} />
    </div>
  );
}
